import { CcfList } from '@nice-ccf/ui-controls';
import { useDispatch, useSelector } from 'react-redux';
import CcfAudioPlayer from '../ccf-audio-player/ccf-audio-player';
import {
  getAttachments,
  getRecordingStatus,
  removeAttachment,
} from '../ccf-inbox/ccf-inbox.slice';
export const AUDIO_FILE_TYPES = [
  'audio/aac',
  'audio/amr',
  'audio/mpeg',
  'audio/mp4',
  'audio/ogg',
];

export interface AttachmentType {
  attachmentId?: string;
  id: string;
  name: string;
  size: number;
  mimeType: string;
  uploaded: boolean;
  url: string;
  isInline?: boolean;
  isForwardedAttachment?: boolean;
}
/**
 * Used as file attachment container
 * @returns returns jsx element of audio player
 * @example -
 * ```
 * <CcfAttachmentContainer/>
 * ```
 */
export function CcfAttachmentContainer() {
  const attachments = useSelector(getAttachments);
  const isVoiceRecordingInProgress = useSelector(getRecordingStatus);
  const dispatch = useDispatch();

  /**
   * Used to remove attachment based on attachment id
   * @param id - attachment id
   * @example -
   * ```
   * <CcfFileUploadItem
   * {...{removeAttachment: handleRemoveAttachment}}
   * />
   * ```
   */
  const handleRemoveAttachment = (id: string) => {
    dispatch(removeAttachment(id));
  };

  /**
   * Returns spinner while recording is in progress
   * @returns JSX element for circular progress
   * @example - checkForVoiceRecorderSpinner()
   */
  const checkForVoiceRecorderSpinner = () => {
    return (
      isVoiceRecordingInProgress && (
        <CcfAudioPlayer
          isVoiceRecordingInprogress
          audioPlayerWidth={'60%'}
          audioUrl={''}
          isInbound={false}
        />
      )
    );
  };

  /**
   * Used to create listItem JSX based on the attachments
   * @example -
   * ```
   * {updateFileList()}
   * ```
   */
  const updateFileList = () =>
    attachments &&
    attachments.length > 0 && (
      <CcfList>
        {attachments
          .filter((file) => AUDIO_FILE_TYPES.includes(file.fileType))
          .map((file: any) => {
            return (
              <CcfAudioPlayer
                key={file.id}
                fileName={file.fileName}
                audioPlayerWidth={'100%'}
                audioUrl={file.downloadLink ?? ''}
                attachmentId={file.id}
                shouldShowCloseIcon
                handleRemoveAttachment={handleRemoveAttachment}
                isInbound={false}
              />
            );
          })}
      </CcfList>
    );
  return (
    <>
      {updateFileList()}
      {checkForVoiceRecorderSpinner()}
    </>
  );
}

export default CcfAttachmentContainer;
